<template>
  <fragment>
    <b-nav-item to="/payment/add" class="waves-effect waves-light">
      <span style="margin-left: 5px">
        {{ getBalanceUnReadMessage.balance }} ریال
      </span>
      <b-icon icon="cash"></b-icon>
      <span class="title-badge">اعتبار</span>
    </b-nav-item>
    <b-nav-item to="/ticket/list" class="waves-effect waves-light">
      <b-icon icon="chat-left-text-fill"></b-icon>
      <b-badge
        v-if="getBalanceUnReadMessage.numOfUnReadMessage !== 0"
        variant="danger"
        pill
        class="badge-custom"
      >
        {{ getBalanceUnReadMessage.numOfUnReadMessage }}
      </b-badge>
      <span class="title-badge">تیکت ها</span>
    </b-nav-item>
    <ProfileHeader />
  </fragment>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ProfileHeader from "./ProfileHeader/ProfileHeader";
import { SET_HEADER_INFO } from "@/store/mutation-types";
import { GET_BALANCE_UNREAD_MESSAGE } from "@/store/mutation-types";

export default {
  name: "BadgeItems",
  components: {
    ProfileHeader
  },
  data() {
    return {
      info: null,
      balance: ""
    };
  },
  mounted() {
    this[SET_HEADER_INFO]();
  },
  computed: {
    ...mapGetters("header", [GET_BALANCE_UNREAD_MESSAGE])
  },
  methods: {
    ...mapActions("header", [SET_HEADER_INFO])
  }
};
</script>

<style>
.badge-custom {
  position: absolute;
  top: 10px;
  right: 0px;
  font-family: iran-sans-num;
  -webkit-transform: translate(0, -2px);
  -ms-transform: translate(0, -2px);
  -o-transform: translate(0, -2px);
  transform: translate(0, -2px);
}
.title-badge {
  position: absolute;
  top: calc(100% + 5px);
  left: 50%;
  padding: 8px 10px;
  color: #ffffff;
  background-color: rgba(0, 0, 0, 0.7);
  text-align: center;
  white-space: nowrap;
  border-radius: 2px;
  opacity: 0;
  visibility: hidden;
  -webkit-transform: translateX(-50%) translateY(3px);
  -moz-transform: translateX(-50%) translateY(3px);
  -ms-transform: translateX(-50%) translateY(3px);
  -o-transform: translateX(-50%) translateY(3px);
  transform: translateX(-50%) translateY(3px);
  -webkit-transition: opacity 0.2s 0s, visibility 0s 0.2s,
    -webkit-transform 0.2s 0s;
  -moz-transition: opacity 0.2s 0s, visibility 0s 0.2s, -moz-transform 0.2s 0s;
  transition: opacity 0.2s 0s, visibility 0s 0.2s, transform 0.2s 0s;
}
.waves-effect:hover .title-badge {
  opacity: 1;
  visibility: visible;
  font-style: normal !important;
  transform: translateX(-50%);
  transition: opacity 0.2s 0s, visibility 0s 0s, transform 0.2s 0s;
}
.title-badge::after {
  content: "";
  position: absolute;
  left: 50%;
  right: auto;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  transform: translateX(-50%);
  top: -5px;
  height: 0;
  width: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid rgba(0, 0, 0, 0.6);
  border-top-color: rgba(0, 0, 0, 0.7);
}
</style>
